import React from 'react';

// Wrapper genérico pra qualquer controle (Input, Select, Textarea,
// DatePicker custom…). Centraliza label + required + error + helpText.
// O Input já tem isso embutido por backward-compat; use FormField quando
// seu child NÃO é Input (ex: <FormField label="..."><Select .../></FormField>).
const FormField = ({
  label,
  required = false,
  error,
  helpText,
  htmlFor,
  children,
  className = '',
}) => {
  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label htmlFor={htmlFor} className="block text-sm font-medium text-app-text mb-1">
          {label}
          {required && <span className="text-error ml-1">*</span>}
        </label>
      )}
      {children}
      {error && <p className="mt-1 text-sm text-error">{error}</p>}
      {helpText && !error && (
        <p className="mt-1 text-xs text-app-text-secondary">{helpText}</p>
      )}
    </div>
  );
};

export default FormField;
